export const EMBED_LOCATION = ["lng", "lat", "zoom"];
